// src/services/notificationService.js
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const getHeaders = () => {
  const token = localStorage.getItem('auth_token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

export const notificationService = {
  getNotifications: async (page = 1, pageSize = 20) => {
    try {
      const response = await fetch(`${BASE_URL}/notifications/?page=${page}&page_size=${pageSize}`, {
        method: 'GET',
        headers: getHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch notifications: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  },

  getUnreadCount: async () => {
    try {
      const response = await fetch(`${BASE_URL}/notifications/unread_count/`, {
        method: 'GET',
        headers: getHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`Failed to fetch unread count: ${response.status}`);
      }
      
      const data = await response.json();
      return data.unread_count;
    } catch (error) {
      console.error('Error fetching unread count:', error);
      return 0;
    }
  },

  markAsRead: async (notificationId) => {
    try {
      const response = await fetch(`${BASE_URL}/notifications/${notificationId}/mark_as_read/`, {
        method: 'POST',
        headers: getHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`Failed to mark notification as read: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  },

  markAllAsRead: async () => {
    try {
      const response = await fetch(`${BASE_URL}/notifications/mark_all_as_read/`, {
        method: 'POST',
        headers: getHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`Failed to mark all notifications as read: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  },

  // NEW: Bulk mark as read
  bulkMarkAsRead: async (notificationIds) => {
    try {
      const response = await fetch(`${BASE_URL}/notifications/bulk_mark_as_read/`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ notification_ids: notificationIds })
      });
      
      if (!response.ok) {
        throw new Error(`Failed to bulk mark notifications as read: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error bulk marking notifications as read:', error);
      throw error;
    }
  },

  // NEW: Bulk delete
  bulkDelete: async (notificationIds) => {
    try {
      const response = await fetch(`${BASE_URL}/notifications/bulk_delete/`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ notification_ids: notificationIds })
      });
      
      if (!response.ok) {
        throw new Error(`Failed to bulk delete notifications: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error bulk deleting notifications:', error);
      throw error;
    }
  },

  deleteNotification: async (notificationId) => {
    try {
      const response = await fetch(`${BASE_URL}/notifications/${notificationId}/`, {
        method: 'DELETE',
        headers: getHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`Failed to delete notification: ${response.status}`);
      }
      
      return true;
    } catch (error) {
      console.error('Error deleting notification:', error);
      throw error;
    }
  }
};